import React from "react";
import type { Film } from "../../types/film";
export function TrailerCard({
  film
}: {
  film: Film;
}) {
  return <article className="group/card relative" tabIndex={0} aria-label={`${film.title}, ${film.tag}, ${film.label ?? ""}`} data-id="element-56" data-mp="40ifnz3izn00">
      <div className="relative flex aspect-video flex-col justify-center overflow-hidden rounded-[20px] bg-black" data-id="element-57" data-mp="8wz8h6lo6pjf">
        <span className="absolute left-4 top-[6%] font-mono text-[10px] tracking-[0.14em] text-signal md:text-[11px]" data-id="element-58" data-mp="dvk751l9x15r">
          {film.tag}
        </span>
        <div className="aspect-[2.39/1] w-full overflow-hidden" data-id="element-59" data-mp="mx9xs57bzw2h">
          <img src={film.image} alt={film.alt} loading="lazy" className="h-full w-full object-cover brightness-[0.6] transition-[transform,filter] duration-[250ms] ease-out group-hover/card:scale-[1.04] group-hover/card:brightness-100 group-focus/card:brightness-100" data-id="element-60" data-mp="rp1teu5cgrzh" />
        </div>
        <div className="absolute inset-x-4 bottom-[6%] flex items-center justify-between font-mono text-[10px] tracking-[0.12em] text-white/70 md:text-[11px]" data-id="element-61" data-mp="16n3vt10n37f5">
          <span data-id="element-62" data-mp="1oqgc0vbjente">2.39:1</span>
          <span data-id="element-63" data-mp="1op57uue6je1r">{film.label}</span>
        </div>
      </div>
      <div className="mt-3 flex items-baseline justify-between gap-3 px-1" data-id="element-64" data-mp="1jr3qcdwejmse">
        <h3 className="font-serif text-[22px] leading-none text-white" data-id="element-65" data-mp="1jt6d8p29czsw">{film.title}</h3>
        <span className="font-mono text-[11px] tracking-[0.08em] text-foot" data-id="element-66" data-mp="1frbdvq3w0whr">{film.meta}</span>
      </div>
    </article>;
}